import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

export const GridItemComponent = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  height: '100%',
  width: '100%',
}))

export const DivMainImg = styled('div')(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2),
}))

export const MainImg = styled('img')(() => ({
  width: '100%',
  height: '100%',
  maxHeight: '450px',
  objectFit: 'cover',
}))

export const DivHeadlines = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
}))

export const TypographyContactUs = styled(Typography)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  width: '100%',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))

export const DivContactUs = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
}))

export const DivMap = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
}))
